export default {
  title: 'Passenger Information',
  form: {
    fields: {
      firstName: {
        label: 'First Name',
        required: 'First Name is required',
      },
      lastName: {
        label: 'Last Name',
        required: 'Last Name is required',
      },
      email: {
        label: 'Email',
        required: 'Email is required',
      },
      phone: {
        label: 'Phone',
      },
    },
  },
};